<template>
  <div class="ShapeTool">
    <div class="header-colors">
      <div>
        <font-awesome-icon :icon="['fas', 'fill']" />
        <span class="text-unselect ml-1">{{ $t("builder.colors") }}</span>
      </div>
      <div class="switch">
        <span class="text-unselect">{{ $t("builder.fill") }}</span>
        <d-switch v-model="isFill" />
      </div>
    </div>
    <div class="options">
      <div
        v-for="color in ANNOTATION_COLORS"
        :key="color"
        :class="['option', { active: config.stroke === color }]"
        @click="selectColor(color)"
      >
        <div class="option-circle" :style="{ backgroundColor: color }" />
      </div>
    </div>
    <div class="hr" />
    <div>
      <font-awesome-icon :icon="['fas', 'border-bottom-right']" />
      <span class="text-unselect ml-1">{{ $t("builder.stroke") }}</span>
    </div>
    <div class="options">
      <div
        v-for="stroke in strokeOptions"
        :key="stroke.type"
        :class="['option', { active: config.strokeType === stroke.type }]"
        @click="selectStrokeType(stroke.type)"
      >
        <component v-if="stroke.component" :is="stroke.component" />
        <font-awesome-icon v-else :icon="stroke.icon" />
      </div>
    </div>
  </div>
</template>

<script>
import DIconDashed from "@/components/icons/annotation/DIconDashed.vue";
import DIconSolid from "@/components/icons/annotation/DIconSolid.vue";
import DSwitch from "@/components/ui_components/DSwitch.vue";
import { ANNOTATION_COLOR, ANNOTATION_COLORS, STROKE_TYPE } from "@/constants/annotationStatus";
export default {
  name: "BuilderAnnotationShapeTool",
  props: {
    config: Object,
  },
  components: { DIconDashed, DIconSolid, DSwitch },
  data() {
    return {
      ANNOTATION_COLORS,
      strokeOptions: [
        { type: STROKE_TYPE.SOLID, component: "DIconSolid" },
        { type: STROKE_TYPE.DASHED, component: "DIconDashed" },
        { type: STROKE_TYPE.NONE, icon: ["fas", "ban"] },
      ],
    };
  },
  computed: {
    isFill: {
      get() {
        return this.config.fill !== ANNOTATION_COLOR.TRANSPARENT;
      },
      set(value) {
        this.switchFill(value);
      },
    },
  },
  methods: {
    lightenColor(hex, lightenPercent = 80) {
      // Helper function to calculate new color channel
      const lightenChannel = (channel) => Math.min(255, Math.floor(channel + (255 - channel) * (lightenPercent / 100)));

      // Remove "#" and split hex to RGB
      const [r, g, b] = hex
        .replace("#", "")
        .match(/.{2}/g)
        .map((color) => parseInt(color, 16));

      // Calculate new RGB and return as HEX
      const [newR, newG, newB] = [r, g, b].map(lightenChannel);

      return `#${[newR, newG, newB].map((c) => c.toString(16).padStart(2, "0")).join("")}`;
    },
    switchFill(isFill) {
      const value = isFill ? this.lightenColor(this.config.stroke) : ANNOTATION_COLOR.TRANSPARENT;
      this.$emit("handleNoteStyleChange", {
        id: this.config.id,
        props: {
          fill: value,
          // prevent not stroke and fill in same time
          ...(this.config.strokeType === STROKE_TYPE.NONE && !isFill ? { strokeType: STROKE_TYPE.SOLID } : {}),
        },
      });
    },
    selectColor(value) {
      this.$emit("handleNoteStyleChange", {
        id: this.config.id,
        props: {
          stroke: value,
          ...(this.isFill ? { fill: this.lightenColor(value) } : {}),
        },
      });
    },
    selectStrokeType(value) {
      this.$emit("handleNoteStyleChange", {
        id: this.config.id,
        props: {
          strokeType: value,
          // prevent not stroke and fill in same time
          ...(value === STROKE_TYPE.NONE && !this.isFill ? { fill: this.lightenColor(this.config.stroke) } : {}),
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.ShapeTool {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 4px;
  color: var(--brand-white);
  font-size: 12px;
  gap: 4px;
  .text-unselect {
    user-select: none;
  }
  .header-colors {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .switch {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  .hr {
    border-top: 1px solid var(--dGrey5-color);
    width: 100%;
    margin: 2px 0;
  }
  .options {
    display: flex;
    gap: 4px;
  }

  .option {
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    font-size: 16px;
    &.active {
      background: rgba(255, 255, 255, 0.1);
    }
  }

  .option-circle {
    border-radius: 50%;
    width: 24px;
    height: 24px;
  }
}
</style>
